<template>
  <div>
    <h1>FAQ</h1>
    <h5>Last updated: <span style="opacity: 0.6">December 2025</span></h5>
    <div class="title" @click="setQ0">. How to SignIn ?</div>
    <div v-show="q0" class="description">
      Each available subscription { 30daysFree or Payed } will generate an Access Key <br> AK [ unique SHA256 ] and that key must be used at sign-in.<br>
      In the free 30-days subscription the AK is generated when the PAYLink is generated.<br>
      In the Payed subscription the AK is generated after the payment is completed.
    </div>
    <div class="title" @click="setQ1">. What doest the Dashboard look like ? </div>
    <img v-show="q1" class="small_image"  src="../assets/client-dashboard.png" alt="dashboard details">
    <div class="title" @click="setQ2">. How to use the STRIPE payment service through the UpayS ?</div>
    <div v-show="q2">
      <div class="description">UpayS will generate a payment link called PAYLink.<br>
        After entering your business link [ redirect link ],
        the PAYLink button becomes active and the payment link can be generated.<br>
        Next step is to use this PAYLink in your business application.(e.g. attach the link to a pay button )</div><br>
      <img class="small_image" src="../../src/assets/1_upays-glink.png" alt="paylink">
    </div>
    <div class="title" @click="setQ3">. How to set up the Payment Page?</div>
    <div v-show="q3" class="description"> Your business has the option to choose between 2 payment page design:<br>
      B2B (business to business) or B2C (business to client).<br>
      B2B has 2 additional fields displayed on the payment page - 'Registration number.' and 'VAT Id.',<br>
      as these are data related to a business customer type.
    </div>
    <div class="title" @click="setQ4">. 'Monthly fee' or 'One time fee' ?</div>
    <div v-show="q4" class="description">
      When setup payment page you can choose between 'One time fee' or a 'Monthly fee'.<br>
      'One time fee' requires disabling the field that increments the number of payment months.
    </div>
    <div class="title" @click="setQ5">. How can I preview the generated Payment Page ?</div>
    <div v-show="q5" class="description"> It's very simple - use the 'Preview' button
      <br><br>
      <img class="medium_image" src="../../src/assets/upays_screen_0_1.png" alt="payment_page">
    </div>
    <div class="title" @click="setQ6">. Can I update previously set configuration from Dashboard ?</div>
    <div  v-show="q6" class="description">
      An update button will be show when your configuration change...<br>
      <img class="small_image" src="../../src/assets/upays-update.png" alt="update_page">
    </div>
    <div class="title" @click="setQ7">. How to integrate the customer authentication process into webapp/website ?</div>
    <div v-show="q7" class="description">If your business requires an authentication process, activate the feature by checking the "Generate keys" button<br>
      and each of your customers who pays through UPAYS will be generated a unique payment key [ SHA256 PK ] <br>
      that they can use to authorizes themselves into your webapp/website  <br>
      The next step will be to SignIn with You Business Key then click the button
      <i class="fa fa-user-secret" style="font-size: 20px;color: salmon" aria-hidden="true"></i><br> from dashboard
      and we show  you how to integrate the JS <button> CODE </button> into Your Front End component
      <br>
      <img class="small_image" src="../../src/assets/int_code.png" alt="code_page">
    </div>
    <div class="title" @click="setQ8">. How to View customers payment keys ?</div>
    <div v-show="q8" class="description">
      To view all customers keys you need to use the 'Display' button. The following image shows the result.
      <br><br>
      <img class="small_image" src="../../src/assets/upays-keys.png" alt="keys_page">
      <br>
    </div>
    <div class="title" @click="setQ9">. Create clients on STRIPE platform ?</div>
    <div v-show="q9" class="description">
      Each payment (a new customer for your business) can generate an entity/customer in your STRIPE account.<br>
      You must check the checkbox related to Stripe clients - option available within Dashboard.
    </div>
    <button class="close" @click="this.$router.go(-1)">Back</button>
    <br>
    <br>
  </div>
</template>
<script>

export default {
  name: 'FAQ',
  data() {
    return {
      faq_text:'',
      q1:false,
      q0:false,
      q2:false,
      q3:false,
      q4:false,
      q5:false,
      q6:false,
      q7:false,
      q8:false,
      q9:false,
    }
  },
  mounted() {
    this.faq_text = "FAQ"
    window.scroll(0,0)
  },
  methods: {
    setQ1() {
      this.q1 = !this.q1
    },
    setQ0() {
      this.q0 = !this.q0
    },
    setQ2() {
      this.q2 = !this.q2
    },
    setQ3() {
      this.q3 = !this.q3
    },
    setQ4() {
      this.q4 = !this.q4
    },
    setQ5() {
      this.q5 = !this.q5
    },
    setQ6() {
      this.q6 = !this.q6
    },
    setQ7() {
      this.q7 = !this.q7
    },
    setQ8() {
      this.q8 = !this.q8
    },
    setQ9() {
      this.q9 = !this.q9
    },
  }
}
</script>
<style scoped>
@import "../assets/buttons.css";
 .medium_image {
   width: 50%;
   height: 50%;
   background-color: black;
 }
 .small_image {
   width: 30%;
   height: 30%;
 }
 .description {
   font-size: 20px;
   font-family: "Apple Symbols",fantasy;
 }
 .title {
   color: orangered;
   margin-top: 10px;
   margin-bottom: 15px;
   font-size: 22px;
   cursor: help;
   font-family: Baghdad,Serif,sans-serif;
   opacity: 0.6;
 }
 .title:hover {
   opacity: 1;
 }
 @media (max-width: 430px) {
   .title {
     font-size: 15px;
   }
   .description {
     font-size: 14px;
   }
   .medium_image {
     width: 100%;
     height: 100%;
   }
   .small_image {
     width: 100%;
     height: 100%;
   }
   .large_image {
     width: 100%;
     height: 100%;
   }
 }
</style>